import { useI18n } from "../i18n/LanguageContext";
import { BRAND } from "../config/brand";

export function Legend() {
  const { t } = useI18n();
  return (
    <div className="glass rounded-2xl px-3 py-2.5 shadow-soft animate-fadeIn">
      <div className="mb-1.5 text-[10px] font-semibold uppercase tracking-wider text-ink-500">
        {t("legend")}
      </div>
      <div className="flex items-center gap-3 text-[11px]">
        <LegendDot color={BRAND.ac} label={t("ac")} sub="≤ 22 kW" />
        <LegendDot color={BRAND.dcFast} label={t("fast")} sub="50–150 kW" />
        <LegendDot color={BRAND.dcUltra} label={t("ultraFast")} sub="≥ 150 kW" />
      </div>
    </div>
  );
}

function LegendDot({ color, label, sub }: { color: string; label: string; sub: string }) {
  return (
    <div className="flex items-center gap-1.5">
      <span
        className="inline-block h-2.5 w-2.5 rounded-full ring-2 ring-white"
        style={{ background: color, boxShadow: `0 0 0 1px ${color}33` }}
      />
      <div className="leading-tight">
        <div className="font-medium text-ink-900">{label}</div>
        <div className="text-[9.5px] text-ink-400">{sub}</div>
      </div>
    </div>
  );
}
